import * as RadixDialog from "@radix-ui/react-dialog";
import { StyledButton } from "../components/Button";
import { styled } from "../stitches.config";
import Icon from "../components/Icon";

export function Modal({
  open,
  title,
  onClose,
  children,
}: {
  open: boolean;
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}) {
  return (
    <RadixDialog.Root open={open}>
      <Overlay onClick={() => onClose()} />
      <Content>
        <AcrylicPanelOuter>
          <AcrylicPanelInner>
            <Head>
              <h1>{title}</h1>
              <StyledButton onClick={() => onClose()}>
                <Icon icon="Close" />
              </StyledButton>
            </Head>
            {children}
          </AcrylicPanelInner>
        </AcrylicPanelOuter>
      </Content>
    </RadixDialog.Root>
  );
}

const Head = styled("div", {
  display: "flex",
  justifyContent: "space-between",
  "& h1": {
    fontSize: "$4",
    fontWeight: "$medium",
    margin: 0,
  },
  [`& ${StyledButton}`]: {
    marginTop: -7,
  },
});

const Overlay = styled(RadixDialog.Overlay, {
  position: "fixed",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  background: "$paper10_20",
  pointerEvents: "auto",
});

const Content = styled(RadixDialog.Content, {
  position: "fixed",
  top: "0",
  left: "50%",
  transform: "translate(-50%, 0)",
  marginTop: "5vh",
  cursor: "default",
});

const AcrylicPanelOuter = styled("div", {
  background: "rgba(255, 255, 255, 0.01)",
  border: "0.03125rem solid rgba(255, 255, 255, 0.5)", // 0.5px/16px
  borderRadius: "2rem", // 32px/16px
  padding: "0.09375rem", // padding + border = 2px, so padding is 1.5px/16px
  boxSizing: "border-box",
  backdropFilter: "blur(1rem)",
  position: "relative",
  elevation: 2,
});

const AcrylicPanelInner = styled("div", {
  borderRadius: "1.875rem", // 30px/16px
  padding: "$5",
  background: "$menuBeige",
});
